

const aboutText = `I've worked as a Full Stack and iOS Developer. My days are spent either making
videos about tech or coding. I love finding new ways to motivate others to code through the content I create.
I look for a challenge that scares me at first, that type of challenge have helped me grow faster and learn more than
I could ever expect to in such a short time.`

export default aboutText;